import { z } from 'zod';
// Languages a partner can serve customers in
export const partnerMatchingLanguageSchema = z.enum([
    'de',
    'fr',
    'en',
    'it',
    'sq', // Albanian
    'sr', // Serbian
    'hr', // Croatian
    'tr', // Turkish
    'pt', // Portuguese
    'es', // Spanish
    'ro', // Romanian
    'other',
]);
export const PartnerMatchingLanguage = partnerMatchingLanguageSchema.enum;
